import { useMemo, useState } from "react";
import { useSession } from "../session";
import { Button } from "../ui/Button";
import { ConfirmDialog } from "../ui/Dialog";
import { describeError } from "../ui/errors";
import { formatDateTime } from "../ui/format";
import { GalleryCard } from "../ui/GalleryCard";
import { useGallerySource } from "../ui/GallerySource";
import { PagedFooter } from "../ui/PagedFooter";
import { usePaged } from "../ui/useLoad";

export function HistoryPage() {
  const { client } = useSession();
  const [error, setError] = useState<unknown>(null);
  const [asking, setAsking] = useState(false);
  const list = usePaged(
    (cursor) => client.call("personal.listHistory", { query: { limit: 30, ...(cursor ? { cursor } : {}) } }),
    "history",
  );

  const cards = useMemo(() => list.items.map((i) => i.gallery), [list.items]);
  useGallerySource(cards);

  function remove(gid: number) {
    setError(null);
    client.call("personal.removeHistory", { params: { gid } }).then(
      () => list.setItems((items) => items.filter((i) => i.gallery.gid !== gid)),
      (e: unknown) => setError(e),
    );
  }
  function clear() {
    setAsking(false);
    setError(null);
    client.call("personal.clearHistory").then(
      () => list.reload(),
      (e: unknown) => setError(e),
    );
  }

  return (
    <div className="page">
      <div className="page-head">
        <h1 tabIndex={-1}>기록</h1>
        {list.items.length > 0 && <Button onClick={() => setAsking(true)}>기록 모두 지우기</Button>}
      </div>
      {error !== null && (
        <p className="note note-warn" role="alert">
          {describeError(error)}
        </p>
      )}
      <section className="grid" aria-label="기록 목록">
        {list.items.map(({ gallery, viewedAt, viewCount }) => (
          <GalleryCard key={gallery.gid} card={gallery} to={`/g/${gallery.gid}`} state={{ inApp: true }}>
            <p className="card-extra">
              <span>
                {formatDateTime(viewedAt)} · {viewCount}번
              </span>
              <button type="button" onClick={() => remove(gallery.gid)}>
                기록에서 지우기
              </button>
            </p>
          </GalleryCard>
        ))}
      </section>
      <PagedFooter list={list} emptyTitle="기록이 없습니다">
        <p>리더로 읽은 갤러리가 최근 순서로 여기에 남습니다.</p>
      </PagedFooter>
      {asking && (
        <ConfirmDialog
          title="기록을 모두 지울까요?"
          confirmLabel="모두 지우기"
          onConfirm={clear}
          onCancel={() => setAsking(false)}
        >
          <p>지운 기록은 되돌릴 수 없습니다. 내려받은 파일과 즐겨찾기는 그대로 남습니다.</p>
        </ConfirmDialog>
      )}
    </div>
  );
}
